const permissions = {
  unauthorized: {
    title: "غير مصرح بالوصول",
    description:
      "ليس لديك الصلاحيات اللازمة للوصول إلى هذه الصفحة أو تنفيذ هذا الإجراء. تواصل مع مدير النظام لطلب الصلاحيات المطلوبة.",
    goHome: "العودة للرئيسية",
  },
};

export default permissions;
